import React from 'react';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid2';
import { Pagination } from '@mui/material';

import { ArticleCard } from '~/components/article-card/ArticleCard';
import { ArticleMediaCard } from '~/components/article-media-card/ArticleMediaCard';
import EventCard from '~/components/event-card/EventCard';

const cardData = [
  {
    img: 'https://picsum.photos/800/450?random=1',
    tag: 'Engineering',
    title: 'Revolutionizing software development with cutting-edge tools',
    description:
      'Our latest engineering tools are designed to streamline workflows and boost productivity. Discover how these innovations are transforming the software development landscape.',
    authors: [
      { name: 'Remy Sharp', avatar: '/static/images/avatar/1.jpg' },
      { name: 'Travis Howard', avatar: '/static/images/avatar/2.jpg' },
    ],
  },
  // {
  //     img: 'https://picsum.photos/800/450?random=2',
  //     tag: 'Product',
  //     title: 'Innovative product features that drive success',
  //     description:
  //         'Explore the key features of our latest product release that are helping businesses achieve their goals. From user-friendly interfaces to robust functionality, learn why our product stands out.',
  //     authors: [{name: 'Erica Johns', avatar: '/static/images/avatar/6.jpg'}],
  // },
  // {
  //     img: 'https://picsum.photos/800/450?random=3',
  //     tag: 'Design',
  //     title: 'Designing for the future: trends and insights',
  //     description:
  //         'Stay ahead of the curve with the latest design trends and insights. Our design list-players shares their expertise on creating intuitive and visually stunning user experiences.',
  //     authors: [{name: 'Kate Morrison', avatar: '/static/images/avatar/7.jpg'}],
  // },
  {
    img: 'https://picsum.photos/800/450?random=4',
    tag: 'Company',
    title: "Our company's journey: milestones and achievements",
    description:
      "Take a look at our company's journey and the milestones we've achieved along the way. From humble beginnings to industry leader, discover our story of growth and success.",
    authors: [{ name: 'Cindy Baker', avatar: '/static/images/avatar/3.jpg' }],
  },
  // {
  //     img: 'https://picsum.photos/800/450?random=45',
  //     tag: 'Engineering',
  //     title: 'Pioneering sustainable engineering solutions',
  //     description:
  //         "Learn about our commitment to sustainability and the innovative engineering solutions we're implementing to create a greener future. Discover the impact of our eco-friendly initiatives.",
  //     authors: [
  //         {name: 'Agnes Walker', avatar: '/static/images/avatar/4.jpg'},
  //         {name: 'Trevor Henderson', avatar: '/static/images/avatar/5.jpg'},
  //     ],
  // },
  // {
  //     img: 'https://picsum.photos/800/450?random=6',
  //     tag: 'Product',
  //     title: 'Maximizing efficiency with our latest product updates',
  //     description:
  //         'Our recent product updates are designed to help you maximize efficiency and achieve more. Get a detailed overview of the new features and improvements that can elevate your workflow.',
  //     authors: [{name: 'Travis Howard', avatar: '/static/images/avatar/2.jpg'}],
  // },
];
const eventInfo = [
  {
    title: 'Winter II Gk Training',
    description:
      'Coach Dave and I are looking forward to getting back into the groove with you.',
    date: new Date('2025-01-05 09:00 AM'),
    location: '6959 S Peoria St. Centennial, CO 80112',
    link: '#',
  },
  {
    title: 'Winter II Gk Training',
    description:
      'Led by professional coaches, this camp focuses on diving techniques, shot-stopping, and reflexes. Perfect for aspiring keepers aged 12-18. Bring your gloves and get ready to make some game-changing saves!',
    date: new Date('2025-01-12 09:00 AM'),
    location: '6959 S Peoria St. Centennial, CO 80112',
    link: '#',
  },
  {
    title: 'Winter II Gk Training',
    description:
      'Led by professional coaches, this camp focuses on diving techniques, shot-stopping, and reflexes. Perfect for aspiring keepers aged 12-18. Bring your gloves and get ready to make some game-changing saves!',
    date: new Date('2025-01-19 09:00 AM'),
    location: '6959 S Peoria St. Centennial, CO 80112',
    link: '#',
  },
  {
    title: 'Winter II Gk Training',
    description:
      'Led by professional coaches, this camp focuses on diving techniques, shot-stopping, and reflexes. Perfect for aspiring keepers aged 12-18. Bring your gloves and get ready to make some game-changing saves!',
    date: new Date('2025-01-26 09:00 AM'),
    location: '6959 S Peoria St. Centennial, CO 80112',
    link: '#',
  },
  {
    title: 'Winter II Gk Training',
    description:
      'Led by professional coaches, this camp focuses on diving techniques, shot-stopping, and reflexes. Perfect for aspiring keepers aged 12-18. Bring your gloves and get ready to make some game-changing saves!',
    date: new Date('2025-02-02 09:00 AM'),
    location: '6959 S Peoria St. Centennial, CO 80112',
    link: '#',
  },
  {
    title: 'Winter II Gk Training',
    description:
      'Led by professional coaches, this camp focuses on diving techniques, shot-stopping, and reflexes. Perfect for aspiring keepers aged 12-18. Bring your gloves and get ready to make some game-changing saves!',
    date: new Date('2025-02-09 08:00 AM'),
    location: '6959 S Peoria St. Centennial, CO 80112',
    link: '#',
  },
  {
    title: 'Winter II Gk Training',
    description:
      'Led by professional coaches, this camp focuses on diving techniques, shot-stopping, and reflexes. Perfect for aspiring keepers aged 12-18. Bring your gloves and get ready to make some game-changing saves!',
    date: new Date('2025-02-16 09:00 AM'),
    location: '6959 S Peoria St. Centennial, CO 80112',
    link: '#',
  },
];

const articleInfo = [
  {
    tag: 'Engineering',
    title: 'The future of AI in software engineering',
    description:
      'Artificial intelligence is revolutionizing software engineering. Explore how AI-driven tools are enhancing development processes and improving software quality.',
    authors: [
      { name: 'Remy Sharp', avatar: '/static/images/avatar/1.jpg' },
      { name: 'Travis Howard', avatar: '/static/images/avatar/2.jpg' },
    ],
  },
  {
    tag: 'Product',
    title: 'Driving growth with user-centric product design',
    description:
      'Our user-centric product design approach is driving significant growth. Learn about the strategies we employ to create products that resonate with users.',
    authors: [{ name: 'Erica Johns', avatar: '/static/images/avatar/6.jpg' }],
  },
  {
    tag: 'Design',
    title: 'Embracing minimalism in modern design',
    description:
      'Minimalism is a key trend in modern design. Discover how our design list-players incorporates minimalist principles to create clean and impactful user experiences.',
    authors: [{ name: 'Kate Morrison', avatar: '/static/images/avatar/7.jpg' }],
  },
  {
    tag: 'Company',
    title: 'Cultivating a culture of innovation',
    description:
      'Innovation is at the heart of our company culture. Learn about the initiatives we have in place to foster creativity and drive groundbreaking solutions.',
    authors: [{ name: 'Cindy Baker', avatar: '/static/images/avatar/3.jpg' }],
  },
  {
    tag: 'Engineering',
    title: 'Advancing cybersecurity with next-gen solutions',
    description:
      'Our next-generation cybersecurity solutions are setting new standards in the industry. Discover how we protect our clients from evolving cyber threats.',
    authors: [
      { name: 'Agnes Walker', avatar: '/static/images/avatar/4.jpg' },
      { name: 'Trevor Henderson', avatar: '/static/images/avatar/5.jpg' },
    ],
  },
  {
    tag: 'Product',
    title: 'Enhancing customer experience through innovation',
    description:
      'Our innovative approaches are enhancing customer experience. Learn about the new features and improvements that are delighting our users.',
    authors: [{ name: 'Travis Howard', avatar: '/static/images/avatar/2.jpg' }],
  },
  {
    tag: 'Engineering',
    title: 'Pioneering sustainable engineering solutions',
    description:
      "Learn about our commitment to sustainability and the innovative engineering solutions we're implementing to create a greener future. Discover the impact of our eco-friendly initiatives.",
    authors: [
      { name: 'Agnes Walker', avatar: '/static/images/avatar/4.jpg' },
      { name: 'Trevor Henderson', avatar: '/static/images/avatar/5.jpg' },
    ],
  },
  {
    tag: 'Product',
    title: 'Maximizing efficiency with our latest product updates',
    description:
      'Our recent product updates are designed to help you maximize efficiency and achieve more. Get a detailed overview of the new features and improvements that can elevate your workflow.',
    authors: [{ name: 'Travis Howard', avatar: '/static/images/avatar/2.jpg' }],
  },
  {
    tag: 'Design',
    title: 'Designing for the future: trends and insights',
    description:
      'Stay ahead of the curve with the latest design trends and insights. Our design list-players shares their expertise on creating intuitive and visually stunning user experiences.',
    authors: [{ name: 'Kate Morrison', avatar: '/static/images/avatar/7.jpg' }],
  },
];

function HomeSpa() {
  const [focusedCardIndex, setFocusedCardIndex] = React.useState<number | null>(
    null
  );

  const handleFocus = (index: number) => {
    setFocusedCardIndex(index);
  };

  const handleBlur = () => {
    setFocusedCardIndex(null);
  };

  return (
    <div>
      <Grid container spacing={8} columns={12} sx={{ my: 4 }}>
        <Grid size={{ xs: 12, md: 6 }}>
          <ArticleMediaCard
            article={cardData[1]}
            handleFocus={handleFocus}
            handleBlur={handleBlur}
            focusedCardIndex={focusedCardIndex}
          />
        </Grid>
        <Grid size={{ md: 6 }} sx={{ display: { sm: 'none', md: 'flex' } }}>
          <ArticleMediaCard
            article={cardData[0]}
            handleFocus={handleFocus}
            handleBlur={handleBlur}
            focusedCardIndex={focusedCardIndex}
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          {eventInfo.map((info, index) => (
            <EventCard
              key={index}
              eventTitle={info.title}
              eventDescription={info.title}
              eventDate={info.date}
              eventLocation={info.location}
              eventLink={info.link}
            />
          ))}
        </Grid>
        {articleInfo.map((article, index) => (
          <Grid key={index} size={{ xs: 12, sm: 6, lg: 3 }}>
            <ArticleCard
              index={index}
              article={article}
              handleFocus={handleFocus}
              handleBlur={handleBlur}
              focusedCardIndex={focusedCardIndex}
            />
          </Grid>
        ))}
      </Grid>
      <Box sx={{ display: 'flex', flexDirection: 'row', pt: 4 }}>
        <Pagination
          hidePrevButton
          hideNextButton
          count={10}
          boundaryCount={10}
        />
      </Box>
    </div>
  );
}

export default HomeSpa;
